import React, { useState, useMemo } from 'react';
import { PlusCircle, Edit2, Wallet, Landmark } from 'lucide-react';

import { AccountModal } from './AccountModal';
import { Card } from '../../components/ui/Card';
import { formatCurrency } from '../../utils/helpers';

export const Accounts = ({ accounts, onSaveAccount }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingAccount, setEditingAccount] = useState(null);

    const handleSave = (accountData, isEditing) => {
        const finalData = isEditing ? accountData : { ...accountData, id: `acc-${Date.now()}` };
        onSaveAccount(finalData, isEditing);
        setIsModalOpen(false);
        setEditingAccount(null);
    };

    const handleOpenModal = (account = null) => {
        setEditingAccount(account);
        setIsModalOpen(true);
    };

    const totalBalance = useMemo(() => accounts.reduce((sum, acc) => sum + acc.balance, 0), [accounts]);

    return (
        <div className="space-y-6">
            <div className="flex justify-between items-center">
                <h2 className="text-3xl font-bold text-gray-800">Quản lý Tài khoản</h2>
                <div className="flex items-center gap-4">
                    <div className="text-right">
                         <p className="text-sm text-gray-500">Tổng số dư</p>
                         <p className="text-xl font-bold text-green-600">{formatCurrency(totalBalance)}</p>
                    </div>
                    <button onClick={() => handleOpenModal()} className="flex items-center gap-2 bg-blue-600 text-white font-semibold py-2 px-4 rounded-lg shadow-md hover:bg-blue-700 transition">
                        <PlusCircle size={20} /> Thêm tài khoản
                    </button>
                </div>
            </div>

            <AccountModal isOpen={isModalOpen} onClose={() => { setIsModalOpen(false); setEditingAccount(null); }} onSave={handleSave} existingAccount={editingAccount} />

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {accounts.map(acc => (
                     <Card key={acc.id} title={acc.name} value={formatCurrency(acc.balance)} icon={acc.type === "Tiền mặt" ? <Wallet/> : <Landmark/>}>
                        <button onClick={() => handleOpenModal(acc)} className="p-2 rounded-full hover:bg-gray-200 text-gray-500 hover:text-blue-600">
                            <Edit2 size={16}/>
                        </button>
                     </Card>
                ))}
            </div>
        </div>
    )
}